import React from "react";
import { DatePicker } from "@gw/web-basic-components";
import type { ColRangeProps } from "./dto";

/**
 * 列头搜索-时间范围组件
 */
const ColDatePicker = (props: ColRangeProps) => {
  return (
    <DatePicker.RangePicker
      value={props.val}
      picker="date"
      // showTime
      size="small"
      style={{ width: 340 }}
      onChange={(dates) => props.setVal(dates)}
      allowClear={false}
    />
  );
};

export default ColDatePicker;
